import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getPublishedPosts } from "../../../../api/blogAPI";

const BASE = process.env.REACT_APP_EXPRESS_API_BASE_URL || "http://localhost:3001";

const resolveImg = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${BASE}${url}`;
};

const BlogTab = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPublishedPosts()
      .then(setPosts)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-24 rounded-2xl bg-zinc-800/50 animate-pulse" />
        ))}
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="py-20 flex flex-col items-center text-zinc-600">
        <svg className="w-10 h-10 mb-3 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
        </svg>
        <p className="text-sm font-semibold">No posts yet</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center gap-3 mb-5">
        <div className="h-1 w-6 bg-blue-500 rounded-full" />
        <span className="text-[10px] font-black uppercase tracking-[0.3em] text-blue-400">Latest Articles</span>
        <Link to="/blog" className="ml-auto text-[10px] text-blue-400 hover:text-blue-300 font-semibold">
          View all →
        </Link>
      </div>
      <div className="space-y-3">
        {posts.map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

const PostCard = ({ post }) => {
  const cover = resolveImg(post.cover_img);

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex gap-4 bg-zinc-900/60 border border-zinc-800 hover:border-blue-600/40 rounded-2xl p-4 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-blue-900/10 block"
    >
      {cover && (
        <div className="flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden bg-zinc-800">
          <img
            src={cover}
            alt={post.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      )}
      <div className="flex-1 min-w-0 flex flex-col justify-between">
        <div>
          <h2 className="text-white font-bold text-sm leading-snug group-hover:text-blue-300 transition-colors line-clamp-2">
            {post.title}
          </h2>
          {post.excerpt && (
            <p className="text-zinc-400 text-xs mt-1 leading-relaxed line-clamp-2">{post.excerpt}</p>
          )}
        </div>
        <div className="flex items-center gap-3 mt-2">
          {post.published_at && (
            <span className="text-[10px] text-zinc-600 font-mono">
              {new Date(post.published_at).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </span>
          )}
          {post.view_count != null && (
            <>
              <span className="text-zinc-700">·</span>
              <span className="text-[10px] text-zinc-600">{post.view_count} views</span>
            </>
          )}
          <div className="ml-auto flex items-center gap-1 text-blue-400 text-[10px] font-bold opacity-0 group-hover:opacity-100 transition-opacity">
            Read
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogTab;
